




import {Component, Prop, Vue} from 'vue-property-decorator'
import RenderData from '@/components/render/RenderData.vue'

@Component({
  components: {RenderData},
})
export default class RenderNumber extends Vue {
  @Prop({type: [Number, String], default: null}) number!: number | string | null
}
